import type { SVGProps } from 'react';

const SvgChevronLargeIsolatedN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 16.008c-.26 0-.51-.1-.71-.29L12 8.428l-7.29 7.29a.996.996 0 1 1-1.41-1.41l7.99-8.01a.996.996 0 0 1 1.41 0l8 8a.996.996 0 0 1-.71 1.7z"
    />
  </svg>
);
export default SvgChevronLargeIsolatedN;
